import { Server, Serializer } from 'miragejs'

export default (environment = 'test') => {
  return new Server({
    serializers: {
      application: Serializer.extend({
        root: false,
        embed: true
      })
    },
    environment,
    models: {
    },
    factories: {
    },
    seeds () {},
    routes () {
      this.urlPrefix = process.env.API_URL
      this.passthrough()
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/shared/plugins/Mirage.js